import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "@mui/material";
import { clientConfigFn } from "clientConfig";
import { Link } from "react-router-dom";
const LogoImg = styled("img")(() => ({
    width: "auto",
    maxWidth: clientConfigFn().logoWidth === 0 ? "16rem" : clientConfigFn().logoWidth,
    maxHeight: clientConfigFn().logoHeight === 0
        ? "3rem"
        : clientConfigFn().logoHeight,
    "@media screen and (max-width: 959px)": {
        maxWidth: clientConfigFn().logoWidthMobile === 0
            ? "10rem"
            : clientConfigFn().logoWidthMobile,
        maxHeight: clientConfigFn().logoHeightMobile === 0
            ? "2rem"
            : clientConfigFn().logoHeightMobile,
    },
}));
const SanitisedLogo = (props) => {
    const regex = /^(https?:\/\/[a-zA-Z0-9.-]+(:[0-9]+)?\/client\/images\/[a-zA-Z0-9_-]+(\.jpg|\.png|\.jpeg|\.gif|\.svg))|(\/client\/images\/[a-zA-Z0-9_-]+(\.jpg|\.png|\.jpeg|\.gif|\.svg))$/;
    const logo = regex.test(props.logoUri.toLowerCase())
        ? props.logoUri
        : undefined;
    return (_jsx(Link, { to: "", className: "logo-link", children: _jsx(LogoImg, { className: "logo", src: logo, alt: props.siteTitle + " Logo" }) }));
};
export default SanitisedLogo;
